var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAppIconEquotipLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1240 1240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#009CA6",
    d: "M212 0h816c117.1 0 212 94.9 212 212v816c0 117.1-94.9 212-212 212H212c-117.1 0-212-94.9-212-212V212C0 94.9 94.9 0 212 0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    className: "appIconEquotipLive_svg__st1",
    d: "M655.3 512.182v216.8c0 7.7 2 15.4 5.8 22.1 4 7.2 9.2 13.8 15.3 19.4 6.7 6.1 14.4 10.8 22.8 14 8.8 3.4 18.1 5.1 27.5 5.1H954v150.1h111v-488H726.6c-9.4 0-18.7 1.7-27.5 5.1-8.4 3.1-16.1 7.7-22.8 13.5a70.22 70.22 0 00-15.3 19.4c-3.7 6.9-5.7 14.7-5.7 22.5zm110.5 51.4c0-1.5.1-2.9.3-4.3v-.8c.1-.9.3-1.6.4-2.4 2-10.7 8.8-16.1 20.3-16.1h167.6v163.2H786.9c-5.2 0-9.4-1.1-12.7-3.2-4.8-3.2-7.5-8.7-8.1-16.5 0-.4-.2-.8-.2-1.2l-.1-118.7zM598.2 665V517.7c0-8.9-1.7-17.6-5.1-25.8-3.2-7.9-7.8-15.1-13.5-21.3-5.4-5.9-11.8-10.8-19-14.3-6.6-3.3-13.9-5-21.3-5.1h-305c-7.4.1-14.8 1.8-21.4 5.1-7.2 3.5-13.6 8.3-18.9 14.3-5.8 6.2-10.4 13.5-13.6 21.3-3.4 8.2-5.2 16.9-5.1 25.8v205.6c0 8.9 1.7 17.6 5.1 25.8 3.2 7.9 7.8 15.1 13.6 21.4 5.3 5.9 11.8 10.8 18.9 14.3 6.7 3.3 14 5.1 21.4 5.1h364.1v-88.2H305.9c-15 0-22.4-7.5-22.4-22.4V665h314.7zM283.5 563.2c0-13.1 4.9-20.7 14.5-23 .8-.2 1.6-.4 2.5-.5h.1c1.8-.2 3.6-.3 5.4-.3h161.5c1.7 0 3.5.1 5.2.3h.2c.9.1 1.6.3 2.4.5 9.7 2.2 14.6 9.9 14.6 23v12.9H283.5v-12.9z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIconEquotipLive);
export default new URL("/builds/software-solutions/workspace/web/eagleid-fe-workspace/src/images/appIconEquotipLive.svg", import.meta.url).toString();
export { ForwardRef as ReactComponent };